import React, { useState, useEffect } from 'react';
import GoogleTranslate from '../components/GoogleTranslate';
import VillageSelector from '../components/VillageSelector';
import { logout } from '../slices/authSlice';
import { useDispatch } from 'react-redux';
const Header = () => {
  const [showLogout, setShowLogout] = useState(false);
  const dispatch = useDispatch();
  const handleToggleLogout = () => {
    setShowLogout(!showLogout);
  };
  
  const handleLogout = () => {
    dispatch(logout());
    window.location.href = '/login'; // Redirect to login
  };

  // Close popup when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".user-wrapper")) {
        setShowLogout(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="header">
      <div className="wraper-for-translator">
         <VillageSelector/>
        <div className="language">
          <GoogleTranslate />
        </div>
      </div>

      <div className="header-actions">
        <div className="action-button">
          <i className="fas fa-sync"></i>
          <div className="badge">5</div>
        </div>
        <div className="action-button">
          <i className="fas fa-bell"></i>
          <div className="badge">3</div>
        </div>

        <div className="action-button user-wrapper" onClick={handleToggleLogout} style={{ position: "relative" }}>
          <i className="fas fa-user"></i>
          {showLogout && (
            <div className="logout-popup">
              <button onClick={handleLogout}>Logout</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
 